import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

const Auth = ({children}) => {
    const navigate = useNavigate();
    const { tokenData } = useSelector(state => state?.tokenSlice);
    console.log("Auth Token Data:", tokenData);

    useEffect(() => {
        if (tokenData?.admin !== 'rainboo') {
            navigate("/");
        }
    }, [tokenData])
    return (
        <>
        {children}
        </>
    )
}

export default Auth